import { render, staticRenderFns } from "./TechpackButtons.vue?vue&type=template&id=2015965d&scoped=true"
import script from "./TechpackButtons.vue?vue&type=script&lang=js"
export * from "./TechpackButtons.vue?vue&type=script&lang=js"
function injectStyles (context) {
  
  var style0 = require("./TechpackButtons.vue?vue&type=style&index=0&id=2015965d&prod&scoped=true&lang=css")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "2015965d",
  null
  ,true
)

export default component.exports